import { z } from 'zod';

export const BaseSchema = z.object({
  id: z.string().uuid(),
  deleted: z.boolean().optional(),
  dirty: z.boolean().optional(),
  editedAt: z.coerce.date().optional(),
  createdAt: z.coerce.date().optional(),
  // rev?: string;
  // createdBy: string;
  // createdAt: Date;
  // editedBy?: string;
  // editedAt?: Date;
});

export type Base = z.infer<typeof BaseSchema>;
